export default "__VITE_ASSET__DRQqmXof__"